module.exports = __webpack_public_path__ + "img/lazio.89f1249a.png";